import { useEffect, useState } from "react";
import { getTermsOfUse } from "./requests";

export const useGetTermsContent = ({ modalIsOpen }) => {
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    const getModalContent = async () => {
      if (modalIsOpen && !modalContent) {
        const content = await getTermsOfUse();
        setModalContent(content);
      }
    };
    void getModalContent();
  }, [modalIsOpen, modalContent]);

  return {
    modalContent
  };
};
